import styled from "styled-components";

import { Icon } from "@/components/ui-deprecated";

export const MenuListItemIcon = styled(Icon)`
    color: ${({ theme }) => theme.color.grayDairyDarker};
`;
